<template>
    <base-modal title="Edit Milestone" :visible="true" @close="$emit('close')">
        <base-backend-errors :data="update.error"/>

        <milestone-form
            :loading="update.loading"
            :init_data="copy(milestone)"
            @cancel="$emit('close')"
            @submit="submit"/>
    </base-modal>
</template>

<script>
import { mapState } from 'vuex';
import MilestoneForm from './MilestoneForm.vue';

export default {
    name: 'MilestoneUpdateModal',
    components: { MilestoneForm },
    props: ['space', 'milestone'],
    computed: mapState('milestones', ['update']),
    methods: {
        async submit(data) {
            const milestone = await this.$store.dispatch('milestones/update', {
                milestone_id: this.milestone.id,
                space_id: this.space.id,
                data,
            });

            this.$store.commit('milestones/update_milestone', {
                id: this.milestone.id,
                data: milestone,
            });

            this.$emit('close');
        },
    },
};
</script>
